import pacote from '../../package.json';
import {apiUrl} from './apiAmbiente';

export const VERSAO_BUILD = String(pacote.version).trim();
let versaoServidor = '';
let requisicao = null;
let ultimaConsulta = 0;
const CHAVE_TENTATIVA = 'MB_ATUALIZACAO_EM_CURSO';

export function compararVersoes(a, b) {
  const parse = v => /^\d{1,6}(?:\.\d{1,6}){1,5}$/.test(String(v || '').trim()) ? String(v).trim().split('.').map(Number) : null;
  const x = parse(a), y = parse(b);
  if (!x || !y) return null;
  for (let i = 0; i < Math.max(x.length, y.length); i++) {
    if ((x[i] || 0) !== (y[i] || 0)) return (x[i] || 0) > (y[i] || 0) ? 1 : -1;
  }
  return 0;
}

export function temAtualizacao(build = VERSAO_BUILD, servidor = versaoServidor) {
  return compararVersoes(servidor, build) === 1;
}

export function registrarVersaoServidor(valor) {
  const nova = String(valor || '').trim();
  if (compararVersoes(nova, VERSAO_BUILD) === null || nova === versaoServidor) return;
  versaoServidor = nova;
  // Compatibilidade com consumidores antigos; a versao do token nao escreve mais aqui.
  global.gNewVersion = nova;
  window.dispatchEvent(new Event('youapp:version'));
}

export function versaoServidorAtual() { return versaoServidor; }

export async function consultarVersaoServidor(forcar = false) {
  if (requisicao) return requisicao;
  if (!forcar && ultimaConsulta && Date.now() - ultimaConsulta < 15000) return versaoServidor;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 10000);
  requisicao = (async () => {
    try {
      const response = await fetch(apiUrl('VersaoApp.php') + '?_=' + Date.now(), {
        cache: 'no-store', credentials: 'omit', signal: controller.signal
      });
      if (!response.ok) throw new Error('Consulta de versão indisponível.');
      const data = await response.json();
      if (!data.ok || compararVersoes(data.version, VERSAO_BUILD) === null) throw new Error('Versão inválida.');
      ultimaConsulta = Date.now();
      registrarVersaoServidor(data.version);
      return versaoServidor;
    } finally { clearTimeout(timer); requisicao = null; }
  })();
  return requisicao;
}

export function avisoTentativaAtualizacao(armazenamento = window.sessionStorage) {
  try {
    const tentativa = JSON.parse(armazenamento.getItem(CHAVE_TENTATIVA) || 'null');
    if (!tentativa) return '';
    if (compararVersoes(VERSAO_BUILD, tentativa.esperada) >= 0) {
      armazenamento.removeItem(CHAVE_TENTATIVA);
      return '';
    }
    if (Date.now() - tentativa.quando < 600000) return 'A nova versão ainda não carregou. Tente novamente em instantes ou avise o administrador.';
    armazenamento.removeItem(CHAVE_TENTATIVA);
  } catch (_) { /* Armazenamento indisponivel nao impede atualizacao. */ }
  return '';
}

export async function atualizarAplicativo(ambiente = window) {
  // Uma navegacao completa recarrega todas as rotas; nao e um refresh do React.
  const destino = versaoServidorAtual();
  if (!temAtualizacao(VERSAO_BUILD, destino)) return false;
  const url = new URL(ambiente.location.href);
  url.searchParams.set('_v', destino);
  url.searchParams.set('_r', String(Date.now()));
  try { ambiente.sessionStorage.setItem(CHAVE_TENTATIVA, JSON.stringify({esperada: destino, quando: Date.now()})); } catch (_) {}
  // Desregistrar somente o worker da raiz deste app; nao apaga login, dados ou caches de outros apps.
  if (ambiente.navigator.serviceWorker) {
    try {
      const registros = await Promise.race([
        ambiente.navigator.serviceWorker.getRegistrations(),
        new Promise(resolve => setTimeout(() => resolve([]), 1500))
      ]);
      const raiz = new URL('/', url.origin).href;
      await Promise.race([
        Promise.all(registros.filter(r => r.scope === raiz).map(r => r.unregister())),
        new Promise(resolve => setTimeout(resolve, 1500))
      ]);
    } catch (_) { /* Sem worker, a navegacao continua normalmente. */ }
  }
  ambiente.location.replace(url.toString());
  return true;
}
